import React, { useEffect, useState } from 'react';
import * as s from './customer-journey.module.less';
import * as landingPageStyle from '../landing-page.module.less';
import Pane from '../../pane/pane';
import PaneTitle from '../../pane/pane-title/pane-title';
import cn from "classnames";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const getItemsPerRow = (width) => {
	if( width >= 1280) {
		return 3
	}
	if(width < 1280 && width > 720) {
		return 2;
	}
	return 1
}
const defaultStepsParam = []
const CustomerJourney = ({
  heading = "Der Prozess: Von der Idee zum Prototyp",
  description = "So einfach läuft die Zusammenarbeit mit uns ab:",
	journeySteps = defaultStepsParam,
	 backgroundColor
}) => {
	const [itemsPerRow, setItemsPerRow] = useState(1);
	const [rows, setRows] = useState([]);
	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			const newItemsPerRow = getItemsPerRow(width);
			setItemsPerRow(newItemsPerRow);

			const newRows = [];
			for (let i = 0; i < journeySteps.length; i += newItemsPerRow) {
				newRows.push(journeySteps.slice(i, i + newItemsPerRow));
			}
			setRows(newRows);
		};

		handleResize(); // Initialize on mount
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [journeySteps]);

	const spacerElements = (itemsPerRow * 2) - 2;

  const getGridTemplateColumns = () => {
    let gridTemplateColumns = "";
    for(const i of [...Array(itemsPerRow).keys()]) {
      if(i < itemsPerRow - 1) {
        gridTemplateColumns = gridTemplateColumns + "5fr 1fr ";
      }
      else {
        gridTemplateColumns = gridTemplateColumns + "5fr";
      }
    }
    return gridTemplateColumns;
  }

  return (
    <Pane
        bgColor={backgroundColor ?? '#f9f9f9'}
    >
      <div className={landingPageStyle.container}>
        <PaneTitle
            title={heading}
            description={description}
            isCentered
            isWhite
        />
        <div className={s.journeyGrid}>
          {rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className={cn(s.journeyRow, {
                  [s.reverse]: rowIndex % 2 !== 0,
                })}
                style={{
                  gridTemplateColumns: getGridTemplateColumns(),
                }}
              >
                {row.map((step, stepIndexInRow) => {
                  const overallStepIndex = rowIndex * itemsPerRow + stepIndexInRow;
                  return (
                      <React.Fragment key={overallStepIndex}>
                        <div className={s.journeyStepCell}>
                          <div className={s.imagePlaceholder}>
							  <GatsbyImage
								  className={s.illustration}
								  alt={heading}
								  loading={"eager"}
								  image={step.img?.childImageSharp?.gatsbyImageData}
							  />
                          </div>
                          <div className={s.stepContent}>
                            <div className={s.stepNumber}>{overallStepIndex + 1}</div>
                            <div className={s.textContent}>
                              <h4>{step.title}</h4>
                              <p>{step.description}</p>
                            </div>
                          </div>

                        </div>
                        {/* Render horizontal connector if not the last step in the row AND not the last item overall */}
                        {stepIndexInRow < itemsPerRow - 1 && overallStepIndex < journeySteps.length - 1 && (
                            <div className={s.horizontalConnector}>
                              <span>&rsaquo;</span>
                            </div>
                        )}
                      </React.Fragment>
                  );
                })}

                {[...Array(spacerElements).keys()].map((_, i) => (
                    <div/>
                ))}
                  <div className={s.verticalConnector}>
                {rowIndex < (journeySteps.length / itemsPerRow) - 1 && (
                      <span className={cn(s.arrow, {
                        [s.rotated]: rowIndex % 2 !== 0,
                      })}>&rsaquo;</span>
                  )}
                </div>


              </div>
          ))}

        </div>
      </div>
    </Pane>
  );
};

export default CustomerJourney;
